import * as $ from 'jquery';
import { RepeatableFieldGroupCommon } from './repeatable-field-group-common';

export class RepeatableFieldGroupFrontend {

    static init() {
        $(document).ready(() => {
            setTimeout(()=>{
                $('.repeatable-component').each((ind,item)=>{
                    RepeatableFieldGroupCommon.initRepeatableFieldGroup($(item));
                });
            },3000);

            $(document).on('change click focus', '.simple-select', function() {
                let siblingSelects = $('[name="'+$(this).attr('name')+'"]');
                // @ts-ignore
                let selectedValues = siblingSelects.map(function (index, item) {
                    return $(item).val();
                }).get();

                siblingSelects.find('option').each(function() {
                    // @ts-ignore
                    $(this).attr('hidden', selectedValues.indexOf($(this).val()) >= 0)
                });
            });
        });
    }

}
